import { LittleBank } from '@/interface/KKC/repayment';
import { EddaParamType } from '@/pages/KKC/edda/subpages/manageedda/ManageEddav2';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface CommonState {
//   example: string;
// }

const initialState: any = {
  bankstatedata: {},
  eddaData: {
    // cardNum_v: '',
    // userName_v: '',
    // bank_v: '',
  },
  eddaObj: {},
  bankListLen: 0,
  preEddaData: {
    type: EddaParamType,
  },
  eddaApplyId: '',
};

const eddaSlice = createSlice({
  name: 'eddaStore',
  initialState,
  reducers: {
    setBankListLen(state: any, action: PayloadAction<{ bankListLen: number }>) {
      state.bankListLen = action.payload.bankListLen;
    },
    setBankdata(state: any, action: PayloadAction<{ bankstatedata: LittleBank }>) {
      state.bankstatedata = action.payload.bankstatedata;
    },
    setEddaObj(state: any, action: PayloadAction<{ eddaObj: object }>) {
      state.eddaObj = action.payload.eddaObj;
    },
    setEddaData(state: any, action: PayloadAction<{ eddaData: object }>) {
      state.eddaData = action.payload.eddaData;
    },
    clearBank(state: any) {
      state.bankstatedata = {
        cnName: '',
        enName: '',
        enNameAbbr: '',
        code: '',
      };
    },
    clearEddaObj(state: any) {
      state.eddaObj = {};
    },
    clearEddaData(state: any) {
      state.eddaData = {
        cardNum_v: '',
        userName_v: '',
        bank_v: '',
      };
    },
    setPreEddaData(state: any, action: PayloadAction<{ preEddaData: { type: EddaParamType } }>) {
      state.preEddaData = action.payload.preEddaData;
    },
    clearPreEddaData(state: any) {
      state.preEddaData = null;
    },
    setEddaApplyId(state: any, action: PayloadAction<{ eddaApplyId: string }>) {
      state.eddaApplyId = action.payload.eddaApplyId;
    },
    clearEddaApplyId(state: any) {
      state.eddaApplyId = '';
    },
  },
});

const {
  setBankListLen,
  setBankdata,
  setEddaData,
  clearBank,
  clearEddaData,
  clearEddaObj,
  setEddaObj,
  setPreEddaData,
  clearPreEddaData,
  setEddaApplyId,
  clearEddaApplyId,
} = eddaSlice.actions;

export {
  clearBank,
  clearEddaData,
  clearEddaObj,
  setBankdata,
  setBankListLen,
  setEddaData,
  setEddaObj,
  setPreEddaData,
  clearPreEddaData,
  setEddaApplyId,
  clearEddaApplyId,
};

export default eddaSlice.reducer;
